/* A short, visible disclosure beside recipe shopping links. */
(()=>{
 'use strict';
 const message='Shop ingredients and gear using the links below. As an Amazon Associate I earn from qualifying purchases.';
 function update(){
  document.querySelectorAll('.rk_ingredients,.rk_equipment').forEach(panel=>{
   const hasAmazon=[...panel.querySelectorAll('.rk_ingredient_content a[href]')].some(a=>{try{const host=new URL(a.getAttribute('href'),location.href).hostname.toLowerCase();return host==='amzn.to'||host==='link.amazon'||host==='amazon.com'||host.endsWith('.amazon.com')}catch{return false}});
   let note=panel.querySelector('.dtc-recipe-shopping-note');
   if(!hasAmazon){if(note)note.remove();return}
   if(!note){const list=panel.querySelector('ul');if(!list)return;note=document.createElement('p');note.className='dtc-recipe-shopping-note';note.textContent=message;panel.insertBefore(note,list)}
  });
 }
 function start(){const root=document.querySelector('#MainContent');if(!root)return;update();let queued=false;new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;update()})}).observe(root,{childList:true,subtree:true})}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
